const readAllInsuranceTypes = `
query($where: productTypeWhereInput){
    productTypes(where:$where){
      description
      name
      typeId
      tenantId
    }
  }
`
const localizeInsuranceType = `
mutation localizeProduct($l10n: upsertL10nInput){
  upsertL10n(l10n:$l10n){
    errors
    status
  }
}
`

const createInsurer = `
mutation createInsurer($insurer: createInsurerInput!){
  createInsurer(input: $insurer){
    status
    errors
  }
}
`

const createInsuranceType = `
mutation createInsuranceType($input: createProductTypeInput!){
  createProductType(input: $input){
    status
  }
}`

const deleteInsuranceType = `
mutation deleteInsuranceType($typeId: String){
  deleteProductType(typeId: $typeId){
    status
  }
}`

const insurers = `
query insurers($tenantId: String, $ids: [String], $types: [String]){
  insurers(tenantId: $tenantId  ids:$ids, productTypes:$types){
    name
    detailedName
    id
    createdAt
  }
}
`

const deleteInsurer = `
mutation deleteInsurer($id: String) {
  deleteInsurer(id: $id){
    status
  }
}
`

const localizeInsurer = `
mutation localizeInsurer($l10n: upsertL10nInput){
  upsertL10n(l10n:$l10n){
    errors
    status
  }
}
`

const query = {
	insurers,
	readAllInsuranceTypes
}

const mutation = {
	createInsurer,
	localizeInsurer,
	createInsuranceType,
	localizeInsuranceType,
	deleteInsuranceType,
	deleteInsurer
}

export { query, mutation }
